/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import AchievementLevel from '../../../common/components/AchievementLevel';
import AchievementCategory from '../../../common/components/AchievementCategory';
import Link from 'flarum/common/components/Link';
import app from 'flarum/forum/app';
import { slug } from '../../../common';
import Button from 'flarum/common/components/Button';
import Tooltip from 'flarum/common/components/Tooltip';
import extractText from 'flarum/common/utils/extractText';

// Make translation calls shorter
const t = (...args) => app.translator.trans(...args);
const prfx = `${slug}.forum.user.assign_achievement`;

export default class UserAchievementsCategory extends Component {
	oninit(vnode) {
		super.oninit(vnode);
	}

	view() {
		const { category, userAchievements, user } = this.attrs;

		const canUnassign = app.session.user?.attribute('canRemoveAchievement');

		return (
			<div className="UserAchievementsCategory">
				<AchievementCategory category={category}>
					{userAchievements.map((userAchievement) => (
						<div className="UserAchievementContainer">
							<Link
								href={app.route('achievement', {
									id: userAchievement.achievement().id(),
								})}
							>
								<AchievementLevel achievementLevel={userAchievement.achievementLevel()} showDesc={true} />
							</Link>
							{canUnassign && (
								<Tooltip text={t(`${prfx}.unassign_level`)}>
									<Button
										className="Button Button--icon Button--link"
										icon="fas fa-ban"
										title={t(`${prfx}.unassign_level`)}
										onclick={() => {
											if (
												confirm(
													extractText(
														t(`${prfx}.unassign_level_confirm`, {
															name: userAchievement.achievementLevel().name(),
															level: userAchievement.achievementLevel().level(),
															achievementName: userAchievement.achievement().name(),
															displayName: user.displayName(),
														})
													)
												)
											) {
												userAchievement.delete().then(() => m.redraw());
											}
										}}
									/>
								</Tooltip>
							)}
						</div>
					))}
				</AchievementCategory>
			</div>
		);
	}
}
